import {
	GetStreamingChartInfoDocument,
	GetStreamingChartInfoQuery,
	GetStreamingChartInfoQueryVariables,
} from '@/components/graphql/queries/GetStreamingChartInfo.query';
import { useQuery } from '@/helpers/composables/useApollo';
import { captureMessageForSentry } from '@/helpers/sentry-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

type StreamingChartDataOptions = Omit<GetStreamingChartInfoQueryVariables, 'language' | 'country'>;

export function useStreamingCharts(
	options: MaybeRefOrGetter<StreamingChartDataOptions>,
	enabled: MaybeRefOrGetter<boolean> = true
) {
	const { language, country } = storeToRefs(useLanguageStore());

	const variables = computed<GetStreamingChartInfoQueryVariables>(() => ({
		...toValue(options),
		language: language.value,
		country: country.value,
	}));

	const { result, loading, error, fetchMore, onError } = useQuery<
		GetStreamingChartInfoQuery,
		GetStreamingChartInfoQueryVariables
	>(GetStreamingChartInfoDocument, variables, { errorPolicy: 'all', enabled: toValue(enabled) });

	onError(apolloError => {
		captureMessageForSentry(
			'[GraphQL Get Streaming Chart Data]:',
			{ error: apolloError, where: 'useStreamingCharts' },
			'error'
		);
	});

	return { result, loading, error, fetchMore };
}
